import { render, staticRenderFns } from "./UploadConfirmation.vue?vue&type=template&id=27e45142&"
import script from "./UploadConfirmation.vue?vue&type=script&lang=js&"
export * from "./UploadConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports